<template>
    <div class="float-left mr-1">
        <b-button variant="primary" @click.stop="abrirModal()">
            <span> <i class="fa fa-plus mr-2"></i> Inserir Irregularidade</span>
        </b-button>
        <b-modal v-model="mostrarModal" :hide-footer="true">
            <div slot="modal-title">
                Irregularidade -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <irregularidade-form
                ref="irregularidadeForm"
                :operacao="operacao"
                @fechar="fecharModal()"
                @salvar="salvarIrregularidade($event)"
            ></irregularidade-form>
        </b-modal>
    </div>
</template>

<script>
import IrregularidadeForm from './IrregularidadeForm'
import IrregularidadesServicos from './IrregularidadesServicos'

export default {
    components: {
        IrregularidadeForm
    },

    data() {
        return {
            mostrarModal: false,
            operacao: 'INSERÇÃO'
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
            if (this.obterIrregularidadesAtualizadas) {
                this.$emit('obterIrregularidadesAtualizadas')
            }
        },

        salvarIrregularidade(irregularidade) {
            this.$store.dispatch('addRequest')
            IrregularidadesServicos.inserirIrregularidade(irregularidade).then(response => {
                if (response) {
                    if (response.success) {
                        this.obterIrregularidadesAtualizadas = true
                        this.$toast.success(
                            'Registro salvo com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$refs.irregularidadeForm.resetForm()
                        this.fecharModal()
                    } else {
                        this.$refs.irregularidadeForm.setErros(response.errors)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
